export const SET_ALERT_INFO = 'SET_ALERT_INFO';
export const CLEAR_ALERT_INFO = 'CLEAR_ALERT_INFO';
export const SET_IS_MOBILE = 'SET_IS_MOBILE';
export const SET_APPLICATION_STATUS = 'SET_APPLICATION_STATUS';
export const UPDATE_STEPS = 'UPDATE_STEPS';
export const SET_STEPS_COMPLETE = 'SET_STEPS_COMPLETE';
export const SET_OVERALL_SUBMISSION = 'SET_OVERALL_SUBMISSION';
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const CLEAR_GENERAL_STATE = 'CLEAR_GENERAL_STATE';
export const SET_IS_TABLET = 'SET_IS_TABLET';